import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  key: 'mc-storage',
  reducer: (state) => ({
    report: {
      expensesFilter: state.report.expensesFilter,
      fleetUtilizationFilter: state.report.fleetUtilizationFilter,
    },
    invoice: state.invoice,
  }),
})

Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  namespaced: true,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  // strict: process.env.NODE_ENV !== 'production'
  strict: false,
  plugins: [vuexLocal.plugin],
})

export default store
